import React, { useState } from "react";
import * as S from "./MensagemSchemaStyle";

const typeStyles = {
  AVISO: { icon: "📢", color: "#b45309" },
  PROMOCAO: { icon: "🔥", color: "#b91c1c" },
  ATUALIZACAO: { icon: "⚙️", color: "#1d4ed8" },
  NOTICIA: { icon: "📰", color: "#15803d" },
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
  });
};

// Detecta URLs no texto e transforma em links clicáveis
const URL_REGEX = /((?:https?:\/\/|www\.)[^\s]+)/g;

const renderTextWithLinks = (text) => {
  if (!text) return text;

  return text.split(URL_REGEX).map((part, index) => {
    if (/^(https?:\/\/|www\.)/.test(part)) {
      // Remove pontuação final que geralmente não faz parte da URL
      const match = part.match(/^(.*?)([.,;:!?)]*)$/);
      const url = match[1];
      const trailing = match[2];
      const href = url.startsWith("www.") ? `https://${url}` : url;

      return (
        <React.Fragment key={index}>
          <S.TextLink href={href} target="_blank" rel="noopener noreferrer">
            {url}
          </S.TextLink>
          {trailing}
        </React.Fragment>
      );
    }
    return part;
  });
};

export default function MensagemSchema({ message, onClose }) {
  const [isClosing, setIsClosing] = useState(false);
  const styles = typeStyles[message.messageType] || typeStyles.AVISO;

  const handleClose = () => {
    setIsClosing(true);
    // Espera a animação de saída terminar antes de chamar o onClose para remover o item da lista
    setTimeout(() => {
      onClose(message.id);
    }, 500); // Mesmo tempo da animação
  };

  return (
    <S.MessageBox messageType={message.messageType} isClosing={isClosing}>
      <S.MessageHeader>
        <S.Title color={styles.color}>
          <span>{styles.icon}</span>
          {message.title}
        </S.Title>
        <S.CloseButton onClick={handleClose}>&times;</S.CloseButton>
      </S.MessageHeader>
      <S.MessageBody>{renderTextWithLinks(message.text)}</S.MessageBody>
      <S.MessageFooter>
        <S.Timestamp>{formatDate(message.dateCreated)}</S.Timestamp>
        {message.link && (
          <S.Link href={message.link} target="_blank" rel="noopener noreferrer">
            Ver Mais
          </S.Link>
        )}
      </S.MessageFooter>
    </S.MessageBox>
  );
}
